import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { Cotizacion } from '../../../model/interface/Cotizacion';

@Injectable()
export class CotizacionService {

  cotizacion: Cotizacion = {};

  constructor(private http: Http) { }

  create(params: Cotizacion) {

    return this.http.post(`${ environment.API_URL }cotizaciones/solicitud`, params)
      .map(res => {

        this.cotizacion = res.json().data;
        return this.cotizacion;
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/cotizacion/cotizacion.service.ts